<template>
  <div>
    <!--menubar-->
    <navigator @doFold="onedoFold2" :isZ="isZ"></navigator>
    <router-view :key="$route.fullPath" class="mt-16" :class='[unfold ? "pl80" : "pl312"]' :unfold="unfold" @doFold="onedoFold" @openPj="oneOpenPj"></router-view>
    <v-footer color="#dcdcdc" :class='[unfold ? "pl80" : "pl312"]' padless style="position:fixed; bottom:0px; width:100%; z-index:10" v-if="!isAuthed">
      <v-system-bar class="text-center" color="faintHoney" style="width:100% !important;">
        <p class="mb-0 mx-auto">現在未ログイン状態で閲覧しています。<v-btn class="py-0" text @click="authModal=true" style="text-decoration: underline; color:#008CFF;">ログイン</v-btn> して対話に参加しましょう。</p>
      </v-system-bar>
      <v-card-text class="py-0 text-center" v-if="config&&config.inquiry">
        お問い合わせ：<span v-text="config.inquiry"></span>
      </v-card-text>
      <v-card-text class="py-0 text-center">
        <span>&copy;</span> {{ new Date().getFullYear() }} — <strong>Liquitous</strong>
      </v-card-text>
    </v-footer>
    <v-footer color="#dcdcdc" :class='[unfold ? "pl80" : "pl312"]' padless style="position:fixed; bottom:0px; width:100%; z-index:10;" v-else-if="aboutLid&&!(aboutLid.sanka)">
      <v-system-bar class="text-center" color="faintHoney" style="width:100% !important;">
        <p class="mb-0 mx-auto">現在このLidに参加していません。<v-btn class="py-0" text style="text-decoration: underline; color:#008CFF;" @click="LidSankaAlert=true">参加</v-btn>しますか?</p>
      </v-system-bar>
      <v-card-text class="py-0 text-center" v-if="config&&config.inquiry">
        お問い合わせ：<span v-text="config.inquiry"></span>
      </v-card-text>
      <v-card-text class="py-0 text-center">
        <span>&copy;</span> {{ new Date().getFullYear() }} — <strong>Liquitous</strong>
      </v-card-text>
    </v-footer>
    <v-footer color="#dcdcdc" :class='[unfold ? "pl80" : "pl312"]' style="position:fixed; bottom:0px; width:100%; z-index:10;" v-else>
      <v-card-text style="width:100% !important;" class="py-0 text-center" v-if="config&&config.inquiry">
        お問い合わせ：<span v-text="config.inquiry"></span>
      </v-card-text>
      <v-card-text class="py-0 text-center">
        <span>&copy;</span> {{ new Date().getFullYear() }} — <strong>Liquitous</strong>
      </v-card-text>
    </v-footer>

    <!--サインイン画面-->
    <v-dialog v-model="authModal" width="400px" height="60%">
      <auth-view
        defaultView="chooseauth"
        @closeModal="closeAuthModal"
      >
      </auth-view>
    </v-dialog>

    <v-dialog v-model="card_lidsanka" width="600px">
      <v-card class="pa-2 d-flex flex-column" height="200px">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn icon @click="card_lidsanka=false">
            <v-icon color="#E64550">mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-text class="text-center ink--text my-auto" style="font-size:25px;">Lidに参加しました</v-card-text>
        <v-card-actions class="mt-auto">
          <v-spacer></v-spacer>
          <v-chip class="deepAqua white--text" @click="card_lidsanka=false">確認</v-chip>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Lid参加確認画面-->
    <v-dialog v-model="LidSankaAlert" width="800">
      <v-card color="white" elevation="15" class="pt-6">
        <v-card-actions class="d-flex justify-center align-center">
          <v-img class="mr-4" max-height="100%" max-width="8%" src="../../assets/svg/5007red.svg"></v-img>
          <div>
            <p class="font-weight-bold text-h5 text-center">あなたはこのLidに参加していません。</p>
            <p class="font-weight-bold text-h5 text-center mb-0">このLidに参加しますか？</p>        
          </div>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-chip class="ma-4 pa-4" @click="LidSankaAlert = false" >参加しない</v-chip>
          <v-chip class="ma-4 pa-4" @click="LidSankaAlert = false, inLid()" color="deepAqua" dark>参加</v-chip>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import firebase from "firebase/app"
import "firebase/firestore"
import authView from '../../components/auth/authView.vue';
import navigator from '../../components/navigator.vue'
import VueMq from 'vue-mq'
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sp: 959,
    pc: 960
  },
  defaultBreakpoint: 'pc' // customize this for SSR
})
  export default {
    components: {
      navigator,
      authView
    },
    data: () => ({
      unfold: false,
      authModal: false,
      card_lidsanka:false,
      LidSankaAlert:false,
      isZ: false
    }),
    computed:{
      uid() {
        return this.$store.state.auth?.user?.uid || '';
      },
      isAuthed() {
        return this.$store.state.auth?.isAuthed;
      },
      config(){
        return this.$store.state.config
      },
      lid(){
        return this.$store.state.lid
      },
      alid(){
        return this.$store.state.alid
      },
      aboutLid() {
        return this.$store.state.aboutLid
      },
    },
    created() {
    },
    mounted(){
      if(this.$mq === 'sp'){
        this.$router.push('/sp/'+this.$route.path.split('/').slice(2).join('/'))
      }
      if (this.lid != null) {
        this.$store.dispatch('getAboutLid', this.$route.params.id)
      }
    },
    watch: {
      $route () {
        if (this.lid != null) {
          this.$store.dispatch('getAboutLid', this.$route.params.id)
        }
      },
      lid() {
        if (this.lid != null) {
          this.$store.dispatch('getAboutLid', this.$route.params.id)
        }
      },
    },
    methods: {
      inLid(){
        const self = this
        firebase.firestore().collection("0").doc(this.aboutLid.id).collection("liduser").doc(this.uid).set({
          uid: this.uid,
          isActive:true,
          updatedAt: firebase.firestore.FieldValue.serverTimestamp()
        },{merge:true}).then(function(docRef) {
          // 保存に成功した時
          //console.log("USERss Document written with ID: ", docRef.id)
          self.$set(self.aboutLid,"sanka",true)
          console.log("Lid参加完了")
          self.card_lidsanka=true
        }).catch(function(error) {
          // 保存に失敗した時
          console.error("Lid参加失敗: ", error)
        })
      },
      onedoFold(el){
        //console.log("unfold:",el)
        this.unfold = el
      },
      closeAuthModal() {
        this.authModal = false
      },
      onedoFold2(el){
        this.unfold = el
      },
      oneOpenPj(el){
        this.isZ=el
      },
    }
  }
</script>
<style scoped>
.pl312{
  padding-left:312px !important;
}
.pl80{
  padding-left:160px !important;
}
</style>
